import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { getdivResponsibilityThunk } from "../../asyncThunks/overView/overview";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const getDivsionResponsibility = createSlice({
    name: "getDivisionResponsibilityThunk",
    initialState,
    reducers: {
        replaceDivResData: (state, action) => {
            if (state.data?.data?.data) {
                const index = state.data?.data?.data.findIndex((item: any) => {
                    
                    return item?.dndFKId?._id === action.payload?.dndFKId?._id
                })
                state.data.data.data[index] = action.payload;
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getdivResponsibilityThunk.pending, (state, action) => {
            state.error = null;
            state.loading = true;
        });
        builder.addCase(getdivResponsibilityThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(getdivResponsibilityThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export const { replaceDivResData } = getDivsionResponsibility.actions;

export default getDivsionResponsibility.reducer;
